<template>
  <div>
    <el-form :model="searchForm" size="small" inline>
      <el-form-item>
        <el-input
          style="width:280px;"
          v-model="searchForm.buyerOrgName"
          placeholder="请输入买家抬头"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData">
      <el-table-column label="买家抬头" prop="sellerOrgName" min-width="28%">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.buyerOrgName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="待开票重量" prop="invoiceWeight" min-width="16%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.invoiceWeight | formatWeight }}吨</span>
        </template>
      </el-table-column>
      <el-table-column label="待开票数量" min-width="12%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.invoiceQuantity }}件</span>
        </template>
      </el-table-column>
      <el-table-column label="待开票金额" min-width="16%" align="center">
        <template v-slot="scope">
          <span class="c-3">¥{{ scope.row.invoiceAmount | formatMoneyCent }}</span>
        </template>
      </el-table-column>
      <el-table-column label="待开票税额" min-width="16%" align="center">
        <template v-slot="scope">
          <span class="c-3">¥{{ scope.row.taxAmount | formatMoneyCent }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="12%" align="center">
        <template v-slot="scope">
          <el-button type="text" @click="applyInvoice(scope.row)">申请开票</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="total > 0"
      style="text-align:right;margin-top:12px"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="total"
      layout="total, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>

<script>
const defaultSearchForm = {
  buyerOrgName: '',
  pageNo: 1,
  pageSize: 10
}

export default {
  name: 'ChooseList',
  data() {
    return {
      searchForm: { ...defaultSearchForm },
      tableData: [],
      total: 0
    }
  },
  created() {
    this.fetch()
  },
  activated() {
    this.fetch()
  },
  methods: {
    applyInvoice(data) {
      this.$router.push({
        name: 'ChooseApply',
        query: { orgId: data.buyerOrgId, orgName: data.buyerOrgName }
      })
    },
    reset() {
      this.searchForm = { ...defaultSearchForm }
      this.fetch()
    },
    startSearch() {
      this.searchForm.pageNo = 1
      this.fetch()
    },
    handleCurrentChange(page) {
      this.searchForm.pageNo = page
      this.fetch()
    },
    async fetch() {
      try {
        const request = {}
        Object.keys(this.searchForm).forEach(key => {
          if (this.searchForm[key]) {
            request[key] = this.searchForm[key]
          }
        })
        const { success, data } = await this.$post('invoice.seller.queryInvoicePending', {
          request
        })
        if (success) {
          const { totalNum, invoicePendingList } = data[0]
          this.tableData = invoicePendingList
          this.total = totalNum
        } else {
          this.tableData = []
          this.total = 0
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
